import React from 'react';
import { convertRestIdToEwsId } from 'owa-identifiers';
import { LazyItemReadingPaneHost } from 'mini-mail-reading-pane-host';
import { Navigate, useParams } from 'mini-react-router-dom';

export const MailReadingPaneDeepLinkHandler = () => {
    const { itemId } = useParams();
    if (!itemId) {
        return null;
    }

    // Decode the itemId to handle case where it's encoded
    const decodedItemId = decodeURIComponent(itemId);
    const ewsId = convertRestIdToEwsId(decodedItemId);

    if (ewsId !== itemId) {
        const encodedEwsId = encodeURIComponent(ewsId);
        return <Navigate to={`/read/${encodedEwsId}`} replace />;
    } else {
        return <LazyItemReadingPaneHost />;
    }
};
